<template>
    <div>
        <div class="skeleton" v-if="skeleton"></div>
        <div v-if="options && filter">
           
            <div class="drop_block" v-show="!skeleton && options" tabindex="0" @focusout="openDropDown = false">
                <div class="drop_box for_desktop" @click="openDropDown = !openDropDown">
                    <!-- <div class="drop_close" v-show="showResetIcon" @click.stop="resetFilter()">
                        <SvgHeaderSvg  :type="'close'" />   
                    </div> -->
                    <div class="drop_name">
                        <!-- {{ name }} -->
                        {{ filterName }}
                        <span v-if="name != 'sort' && selectedOption.length > 0" class="active_count">({{selectedOption.length}})</span>
                    </div>
                    <div class="drop_arrow">
                        <SvgHeaderSvg v-if="!openDropDown" :type="'down'" />
                        <SvgHeaderSvg v-else :type="'up'" />
                    </div>
                </div>
                <div v-show="openDropDown" class="drop_item" :class="'drop_item_'+name">
                    <div class="title_close">
                        <div class="title">
                            <span>{{ filterName }}:&nbsp;</span>
                            <span class="active_label for_desktop" 
                                v-if="name != 'style' && selectedOption.length">
                                {{selectedOption[0].label}}
                            </span>
                            <div class="eclipse for_desktop" v-if="['style'].includes(name) && selectedOption.length">
                                <span class="active_label" 
                                    v-for="select in selectedOption" :key="select.value"
                                >
                                    {{select.label}},&nbsp;
                                </span>
                            </div>
                        </div>
                        <div class="close for_desktop" @click="openDropDown = false"><SvgHeaderSvg :type="'close'" /></div>
                    </div>
                    <ul class="mb-0" 
                        :class="{
                            'full_ul': ['style', 'sort'].includes(name), 
                            'half_ul': ['shape'].includes(name), 
                            'wrap_ul': ['carat', 'shipdate'].includes(name)
                        }"
                    >
                        <li 
                            v-for="opt in options" :key="opt.value" 
                            :class="{ [opt.icon]: true, 'active': opt.active === 1 }"
                            @click="toggleFilter(opt.value)" 
                        >
                        <div class="me-2 icon_box" v-if="filter.name === 'shape'">
                            <SvgShapeSvg v-if="opt.active === 0" :type="opt.icon" />
                            <SvgShapeSvg class="for_desktop" v-if="opt.active === 1" :type="opt.icon + '_active_green'" />
                            <SvgShapeSvg class="for_mobile" v-if="opt.active === 1" :type="opt.icon + '_active'" />
                        </div>
                        <div class="me-2 icon_box for_mobile" v-if="filter.name === 'metal'">
                            <!-- <SvgMetalSvg  :type="opt.icon" /> -->
                            <img v-if="opt.icon==='white'" width="50" height="50" src="~/assets/metals/white.png" alt="white gold"/>
                            <img v-if="opt.icon==='yellow'" width="50" height="50" src="~/assets/metals/yellow.png" alt="yellow gold"/>
                            <img v-if="opt.icon==='rose'" width="50" height="50" src="~/assets/metals/rose.png" alt="rose gold"/>
                        </div>
                        <div class="me-2 icon_box" v-if="['style', 'category'].includes(filter.name)">        
                            <SvgStyleSvg v-if="opt.active === 0" :type="opt.icon" />
                            <SvgStyleSvg class="for_desktop" v-if="opt.active === 1" :type="opt.icon + '_active_green'" />
                            <SvgStyleSvg class="for_mobile" v-if="opt.active === 1" :type="opt.icon + '_active'" />
                        </div>
                            <span v-if="name==='metal'" class="for_mobile">{{ opt.label }}</span>
                            <span v-if="name==='metal'" class="for_desktop">{{ opt.short_label }}</span>
                            <span v-else>{{ opt.label }}</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<!--  -->

<script setup>
    import { cyolistStore }  from '@/stores/cyolist/cyolist';
    const store = cyolistStore();
    const route = useRoute();

    const {name}  = defineProps(['name'])

    const openDropDown = ref(false)
    const skeleton = ref(true)


    const moduleType = route.meta.moduleType
    const moduleSubType = route.meta.moduleSubType 

    const options = computed(() => {
        let option = store.getSettingFilterOptions( moduleSubType , name )
        return option
    })

    const filter = computed(() => store.getSettingFilter(moduleSubType , name ))

    const showOptions= computed(() => {
        return store.getSettingFilterVisibility(moduleSubType , name )
    })

    const filterName = computed(() => {
        if(name == 'style' && ['shop-all___us', 'shop-all___in'].includes(route.name)){
            return 'category'
        }
        else if(name === 'shipdate'){
            return 'ships by'
        }
        else{
            return name
        }
    })
    const selectedOption = computed(() =>{

        if( options.value && options.value.length > 0){

            return options.value.filter( (cv)=>  { return cv.active === 1  })
        }
        return []
    })
    function getSelectedOption(){
                
        return options.value.filter( (cv)=>  { return cv.active === 1  })
    }
    const showResetIcon = computed(() =>{
        // do not show reset icon on default selection
        let selected = getSelectedOption()
        
        // improve this 
        if (filter.value.default && filter.value.singleSelect && selected.length > 0 ) {

            return selected[0].value === filter.value.default ? false : true
        }

        return getSelectedOption().length > 0 ? true : false
    })

    function toggleFilter(value, reset = false) {
      
        store.toggleSettingFilter({ reset:reset, type: moduleSubType , filter: filter.value , option : { value : value }})
        
        if(!['style', 'category'].includes(filter.value.name) || reset === true){
            store.toggleSettingFilterVisibility({ type: moduleSubType , filter: filter.value, reset : true })
        }

        openDropDown.value = false
    }

    const updateSkeletonState = () => {
       
    };
    function getDefaultSelection(){

        return options.value.find( (cv)=>  { return cv.value === filter.value.default  })
    }
    function resetFilter(){

        // if default selection then active default and reset other options
        if (filter.value.default && getDefaultSelection() ) {

            toggleFilter(getDefaultSelection().value, false)
            return 
        }

        toggleFilter(false, true)
    }
    onMounted(() => {
        if (options.value && filter.value && skeleton.value === true) {
            skeleton.value = false;
        }
    });

    onUpdated(() => {
        if (options.value && filter.value && skeleton.value === true) {
            skeleton.value = false;
        }
    });

</script>

<style scoped>
    .drop_arrow .svg-head {
        height: 18px;
        width: 16px;
    }
    .drop_item_style.drop_item {
        min-width: 220px;
    }
    .drop_close .svg-head {
        height: 22px;
    }
    .skeleton {
        height: 42px;
        border-radius: 8px;
        background: #eaeaea;
        min-width: 85px;
    }
    .drop_box {
        display: flex;
        align-items: center;
        border: 1px solid #c4c4c4;
        border-radius: 8px;
        padding: 8px 12px;
        cursor: pointer;
    }
    .drop_name {
        margin-right: 8px;
        font-size: 14px;
        text-transform: capitalize;
        font-weight: 400;
        color: #212529;
    }
    .drop_name .active_count{
        color: var(--green);
    }
    .drop_item{
        box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.15);
        border-radius: 8px;
        position: absolute;
        top: calc(100% + 8px);
        left: 0;
        background: #fff;
        z-index: 99;
        min-width: 240px;
    }
    .drop_item.drop_item_shape {
        width: 315px;
    }
    .title_close {
        padding: 15px 15px 0 15px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .title_close .title {
        font-size: 14px;
        text-transform: capitalize;
        font-weight: 700;
        color: #000;
        display: flex;
        align-items: center;
    }
    .eclipse {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 130px;
    }
    .close {
        cursor: pointer;
    }
    ul {
        display: flex;
        flex-wrap: wrap;
        padding: 8px 8px 8px 8px;
    }
    ul.half_ul {
        justify-content: space-between;
    }

    ul li {
        list-style: none;
        min-height: 36px;
        min-width: 36px;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        /* flex-wrap: wrap; */
        margin: 5px;
        cursor: pointer;
    }
    ul li.active {
        border: 1px solid var(--green) !important;
    }
    ul li.active span{
        color: var(--green);
        font-weight: 600;
    }
    ul.full_ul li {
        width: 100%;
        justify-content: flex-start;
        border: 1px solid #eaeaea;
        padding: 4px 12px;
    }
    ul.half_ul li {
        width: 46%;
        border: 1px solid #eaeaea;
        justify-content: flex-start;
        padding: 4px 12px;
    }
    ul.wrap_ul li {
        border: 1px solid #eaeaea;
        min-width: 46px;
        padding: 10px;
    }
    ul li.white{
        background: #f5f5f5;
    }
    ul li.yellow{
        background: #f3dda1;
    }
    ul li.rose{
        background: #f3b089;
    }
    .drop_block {
        position: relative;
    }

    ul li span {
        text-transform: capitalize;
        font-size: 14px;
        font-weight: 400;
        color: #606060;
        display: block;
    }
    .active_label{
        color: var(--green);
    }

    @media(max-width: 767px){
        .drop_item.drop_item_shape {
            width: 100%;
        }
        ul.half_ul li{
            justify-content: center;
            min-height: 80px;
            align-items: center;
        }
        .title_close .title{
            text-transform: uppercase;
        }
        .drop_item {
            display: block !important;
            position: relative;
            left: 0;
            top: 0;
        }
        .drop_item {
            box-shadow: none;
        }

        .title_close {
            padding: 0;
        }

        ul {
            padding: 0;
        }

        ul li {
            margin: 0 10px 0 0;
            /* align-content: center; */
        }

       

        .title {
            margin-bottom: 10px;
            display: block;
            width: 100%;
        }
        .drop_block {
            margin-bottom: 20px;
        }

        ul {
            align-items: stretch;
            border: 0;
            display: flex !important;
            overflow-x: scroll;
            overflow-y: hidden;
            padding: 0 0 8px;
            position: relative;
            white-space: nowrap;
            flex-wrap: nowrap;
        }

        ul li {
            align-items: flex-start;
            border: 1px solid #eaeaea;
            border-radius: 4px;
            justify-content: center;
            margin-right: 10px;
            min-width: 95px;
            /* padding: 10px; */
            text-align: center;
            /* min-height: 80px;
            align-items: center; */
        }
        ul li span{
            text-transform: capitalize;
            font-size: 14px;
            font-weight: 500;
            white-space: break-spaces;
        }
        
        ul.full_ul li, ul.half_ul li, ul li{
            /* justify-content: center; */
            flex-direction: column;
            gap: 10px;
            align-items: center;
            justify-content: flex-start;
        }

        ul.wrap_ul li {
            min-width: 65px;
        }
        ul.full_ul li.five_stone {
            justify-content: center;
            align-items: center;
            gap: 15px;
        }
        ul.full_ul li.seven_stone {
            justify-content: center;
            align-items: center;
            gap: 15px;
        }

        .icon_box {
            margin-right: 0 !important;
        }
        
        ul li.white, ul li.yellow, ul li.rose{
            background: #fff;
        }
        
        ul li.active {
            background: var(--green);
        }
        ul li.active span {
            color: #fff;
        }

        ul.full_ul li, 
        ul.half_ul li,
        ul li{
            padding: 14px 12px;
           
        }

       
        

    }
</style>